<!-- MEDICAL -->
@if (!forceHideMedical) {
  <section class="rate-guide-container">
    <h3>{{ medTitle || "MEDICAL RATE GUIDES" }}</h3>
    <hr />
    <div>
      <p class="margin-top">
        {{
          medSubtextOne ||
            "The Rate Guide is a report that displays available plans and rates by age
          and rating area. Rates are subject to benefit changes mandated by law and annual adjustments."
        }}
      </p>
      <p>
        {{
          medSubtextTwo ||
            "Note: Your client’s rate may change when they move into a different rate
          area or change plans. Their rate will also change on an annual renewal date based on their age and benefit.
          "
        }}
      </p>
      <p>
        {{
          medSubtextThree ||
            "Confidential - For producer use only; not for public distribution. For best display use the “Fit” or Shrink “Oversized Pages” in printer settings"
        }}
      </p>
      <p>
        @for (map of medRatingArea; track map) {
          <div class="maps-download">
            <span class="material-symbols-outlined download-symbol">download</span> 
            <a
              class="link"
              [href]="map.linkUrl"
              target="_blank"
              rel="noopener noreferrer"
            > 
              {{ map.linkLabel ||  currentYear + " Health Plans and Rating Areas Maps" }}
            </a>
          </div>
        }
      </p>
    </div>
    @if (!forceHideMedical) {
      <form [formGroup]="medicalDownloadForm">
        <mat-radio-group formControlName="medicalDownloadSelection" required>
          @for (downloadLink of medDownloadLinks; track downloadLink) {
            <mat-radio-button
              class="radio-block"
              [value]="downloadLink.linkUrl"
            >
              {{ downloadLink.linkLabel }}
            </mat-radio-button>
          }
        </mat-radio-group>
        @if (
          (medicalFormControls?.medicalDownloadSelection.dirty ||
            medicalFormControls?.medicalDownloadSelection.touched) &&
          medicalFormControls?.medicalDownloadSelection?.errors?.required
        ) {
          <mat-error>{{ medFormErrorMsg }}</mat-error>
          <br /><br />
        }
        <div class="med-btn-container">
          @if (isUserInternal) {
            <div class="margin-right">
              <button
                mat-raised-button
                color="primary"
                type="button"
                class="download-btn"
                (click)="handleMedicalDownload('excel')"
              >
                {{ medExlDownloadBtn }}
              </button>
            </div>
          }
          <div>
            <button
              mat-raised-button
              color="primary"
              type="button"
              class="download-btn"
              (click)="handleMedicalDownload('pdf')"
            >
              {{ medPdfDownloadBtn }}
            </button>
          </div>
        </div>
      </form>
    }
  </section>
}

<!-- DENTAL -->
@if (!forceHideDental) {
  <section class="rate-guide-container">
    <h3>{{ dentTitle }}</h3>
    <hr />
    <div>
      <p class="margin-top">{{ dentSubtextOne }}</p>
      <p>{{ dentSubtextTwo }}</p>
      <p>{{ dentSubtextThree }}</p>
    </div>
    <form [formGroup]="dentalDownloadForm">
      <mat-radio-group formControlName="dentalDownloadSelection" required>
        @for (downloadLink of dentDownloadLinks; track downloadLink) {
          <mat-radio-button class="radio-block" [value]="downloadLink.linkUrl">
            {{ downloadLink.linkLabel }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (
        (dentalFormControls?.dentalDownloadSelection.dirty ||
          dentalFormControls?.dentalDownloadSelection.touched) &&
        dentalFormControls?.dentalDownloadSelection?.errors?.required
      ) {
        <mat-error> {{ dentFormErrorMsg }} </mat-error>
        <br /><br />
      }
      <a
        (click)="submitForm(dentalDownloadForm)"
        [href]="dentalFormControls?.dentalDownloadSelection?.value"
        download
      >
        <button
          mat-raised-button
          color="primary"
          type="button"
          class="download-btn"
        >
          {{ dentPdfDownloadBtn }}
        </button>
      </a>
    </form>
  </section>
}

<!-- VISION -->
@if (!forceHideVision) {
  <section class="rate-guide-container">
    <h3>{{ visTitle }}</h3>
    <hr />
    <div>
      <p class="margin-top">{{ visSubtextOne }}</p>
      <p class="margin-top">{{ visSubtextTwo }}</p>
      <p class="margin-top">{{ visSubtextThree }}</p>
    </div>
    <form [formGroup]="visionDownloadForm">
      <mat-radio-group formControlName="visionDownloadSelection" required>
        @for (downloadLink of visDownloadLinks; track downloadLink) {
          <mat-radio-button class="radio-block" [value]="downloadLink.linkUrl">
            {{ downloadLink.linkLabel }}
          </mat-radio-button>
        }
      </mat-radio-group>
      @if (
        (visionFormControls?.visionDownloadSelection.dirty ||
          visionFormControls?.visionDownloadSelection.touched) &&
        visionFormControls?.visionDownloadSelection?.errors?.required
      ) {
        <mat-error> {{ visFormErrorMsg }} </mat-error>
        <br /><br />
      }
      <a
        (click)="submitForm(visionDownloadForm)"
        [href]="visionFormControls?.visionDownloadSelection?.value"
        download
      >
        <button
          mat-raised-button
          color="primary"
          type="button"
          class="download-btn"
        >
          {{ visPdfDownloadBtn }}
        </button>
      </a>
    </form>
  </section>
}
